var _ = require('underscore');
var Authorization = require('Authorization');
var Backbone = require('backbone');
var Behaviors = require('Behaviors');
var Language = require('Language');
var Marionette = require('marionette');
var PrivacyPolicy = require('PrivacyPolicy');
var Router = require('Router');
var SessionTimeout = require('Session');
var Validation = require('Validation');

var alerts = {};

alerts["success"] = "alert alert-success alert-dismissible toast-modal";
alerts["info"] = "alert alert-info alert-dismissible toast-modal";
alerts["warning"] = "alert alert-warning alert-dismissible toast-modal";
alerts["danger"] = "alert alert-danger alert-dismissible toast-modal";

var Layout = Marionette.View.extend({
    regions: {
        footer: "#footer",
        header: "#header",
        main: "#main",
        modal: "#modal"
    },
    ui: {
        toastModal: "#toastModal",
        toastLabel: "#toastLabel",
        title: ".eyforms-title"
    },
    events: {
        "click #closeToast": "closeToast"
    },
    closeToast: function () {
        this.ui.toastModal.fadeOut(0);
    },
    template: "#consultationLayout"
});

var Header = Marionette.View.extend({
    behaviors: [{behaviorClass: Authorization.RBAC, viewName: 'menu'}, Behaviors.MobileView],
    events: {
        'click a': 'navigate',
        'click #toggleBar': 'toggleClick',
        'click @ui.logout': 'logout'
    },
    regions: {
        language: '#language'
    },
    template: "#consultationHeader",
    ui: {
        name: '#applicationName',
        iconbar: '#iconBar',
        logout: '#logout'
    },
    onRender: function () {
        this.activate();
        Language.show({
            region: this.getRegion('language')
        });
        this.ui.name.addClass(EY.Consultation.ApplicationName === EY.Consultation.Labels.ApplicationName ? '' : 'ey-red-color');
    },
    activate: function () {
        var $menu = this.$("a[href='#" + _.first(Backbone.history.fragment.split('/')) + "']");

        this.$('.nav-links .active').removeClass("active");
        ($menu.length ? $menu : this.$("#home")).addClass("active");
    },
    navigate: function (e) {
        var $elem = this.$(e.currentTarget);
        if ($elem.attr('id') === "help" || $elem.attr('id') ==="npo") {
            return;
        }
        Router.navigate($elem.attr('href'), { trigger: true });
        this.activate();
        e.preventDefault();
    },
    logout:  function () {
       SessionTimeout.close();
    }
});

var Footer = Marionette.View.extend({
    template: "#consultationFooter",
    events: {
        "click #privacyPolicyLink": "openPrivacyPolicy"
    },
    openPrivacyPolicy: function(e) {
        e.preventDefault();
        PrivacyPolicy.start();
    }
});

module.exports.show = function (options) {
    var regionName = options.regionName || 'main';
    var view = options.view;

    if (module.exports.layout) {
        module.exports.layout.getRegion(regionName).show(view);
    }
};

module.exports.showToast = function (options) {

    if (module.exports.layout) {
        module.exports.layout.ui.toastModal.removeClass();
        module.exports.layout.ui.toastModal.addClass(alerts[options.result]);
        module.exports.layout.ui.toastModal.fadeIn(2000);
        module.exports.layout.ui.toastLabel.text(options.text);
        var timeout = options.result !== "danger" ? 5000 : 10000;
        // After 5 or 10 seconds, remove the show class from DIV
        setTimeout(function () {
            module.exports.layout.ui.toastModal.fadeOut(2000);
            module.exports.layout.ui.toastModal.addClass("hide");
        }, timeout);
    }
};

module.exports.showActionToast = function (options) {

    if (module.exports.layout) {

        module.exports.layout.ui.toastModal.removeClass();
        module.exports.layout.ui.toastModal.addClass(alerts[options.result])
            .removeClass('toast-modal')
            .addClass('toast-modal-custom');
        module.exports.layout.ui.toastModal.fadeIn(2000);
        module.exports.layout.ui.toastLabel.text(options.text);
    }
};

module.exports.hideActionToast = function () {

    if (module.exports.layout) {

        module.exports.layout.ui.toastModal.fadeOut(2000);
        module.exports.layout.ui.toastModal.addClass("hide");
    }
};

module.exports.start = function (options) {
    var consultation = new Marionette.Application({
        region: options ? options.container : '#consultation'
    });
    var layout = new Layout();

    consultation.on("start", function () {
        SessionTimeout.run();
        consultation.showView(layout);
        Validation.configure();
        if (!options || options.history) {
            Backbone.history.start();
        }

        layout.getRegion('header').show(new Header());
        layout.getRegion('footer').show(new Footer());
        var currentUser = EY.Consultation.CurrentUser;
        if (!currentUser.model.get('privacyAck') || currentUser.model.get('privacyAckVersion') !== EY.Consultation.PrivacyPolicyVersion) {
            PrivacyPolicy.start();
        }
    });
    module.exports.application = consultation;
    module.exports.layout = layout;
    consultation.start();
};


// WEBPACK FOOTER //
// ./js/Modules/Application/Consultation.js